import { Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export function LabelValueEditor({ rows, onChange, testid }) {
  const set = (i, k, v) => onChange(rows.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  return (
    <div className="space-y-2" data-testid={testid}>
      {rows.map((r, i) => (
        <div key={i} className="grid grid-cols-[160px_1fr_auto] gap-2 items-start">
          <Input value={r.label} onChange={(e) => set(i, "label", e.target.value)} data-testid={`${testid}-label-${i}`} />
          <Textarea rows={Math.max(1, r.value.split("\n").length)} value={r.value} onChange={(e) => set(i, "value", e.target.value)} data-testid={`${testid}-value-${i}`} />
          <Button size="icon" variant="ghost" onClick={() => onChange(rows.filter((_, j) => j !== i))} data-testid={`${testid}-remove-${i}`}><Trash2 className="h-4 w-4" /></Button>
        </div>
      ))}
      <Button size="sm" variant="outline" onClick={() => onChange([...rows, { label: "", value: "" }])} data-testid={`${testid}-add`}><Plus className="h-4 w-4 mr-1" />Add row</Button>
    </div>
  );
}

const BANK_FIELDS = [["bank", "Bank"], ["accountType", "Account type"], ["accountName", "Account name"], ["accountNumber", "Account number"], ["ifsc", "IFSC"]];

export function BanksEditor({ banks, onChange }) {
  const set = (i, k, v) => onChange(banks.map((b, j) => (j === i ? { ...b, [k]: v } : b)));
  return (
    <div className="space-y-3" data-testid="template-banks">
      {banks.map((b, i) => (
        <div key={i} className="grid grid-cols-2 sm:grid-cols-[repeat(5,1fr)_auto] gap-2 rounded-md border p-2">
          {BANK_FIELDS.map(([k, l]) => <Input key={k} placeholder={l} value={b[k]} onChange={(e) => set(i, k, e.target.value)} data-testid={`bank-${i}-${k}`} />)}
          <Button size="icon" variant="ghost" onClick={() => onChange(banks.filter((_, j) => j !== i))} data-testid={`bank-${i}-remove`}><Trash2 className="h-4 w-4" /></Button>
        </div>
      ))}
      <Button size="sm" variant="outline" onClick={() => onChange([...banks, { bank: "", accountType: "Current", accountName: "GAMERZ NATION", accountNumber: "", ifsc: "" }])} data-testid="bank-add"><Plus className="h-4 w-4 mr-1" />Add bank</Button>
    </div>
  );
}
